import React from 'react';
import { ClipboardListIcon, SearchIcon, SettingsIcon, GitBranchIcon, FileCheckIcon, AwardIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { steps } from '../../data/content';
const icons = [ClipboardListIcon, SearchIcon, SettingsIcon, GitBranchIcon, FileCheckIcon];
export function Pathway() {
  return <section className="bg-ink-900 px-4 py-16 text-white md:px-8 md:py-24" data-id="element-260" data-mp="9ax2mjkxhjib">
      <div className="mx-auto max-w-4xl" data-id="element-261" data-mp="38rlo422wpjry">
        <div className="text-center" data-id="element-262" data-mp="38swsa309ktjl">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-300" data-id="element-263" data-mp="3crdohri5cjm8">Introducing the Endo Retreatment Decision Pathway™</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-tight tracking-tight md:text-[42px]" data-id="element-264" data-mp="3hpxb7u4kdzfn">
            One practical framework. <span className="text-cta-400" data-id="element-265" data-mp="x0zvv30kwvii">Five structured decision steps.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[17px] leading-relaxed text-mist-200" data-id="element-266" data-mp="x3drbcz689ql">
            A clinical organization system built around five essential stages of retreatment assessment and planning.
          </p>
        </div>

        <ol className="relative mt-12 space-y-5" data-id="element-267" data-mp="183nzbnxd7kdz">
          <span className="absolute bottom-6 left-[27px] top-6 w-0.5 bg-brand-500/40 md:left-[31px]" aria-hidden="true" data-id="element-268" data-mp="181tf6btx3way" />
          {steps.map((s, i) => {
          const Icon = icons[i];
          return <li key={s.key} className="relative flex gap-4 md:gap-6" data-id="element-269" data-mp="t6n6fh3ftjdx" data-mpi={i}>
                <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-brand-400 text-ink-950 md:h-16 md:w-16" data-id="element-270" data-mp="t7ybdk8mcx6m">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-271" data-mp="kdjwvjvwxqok" />
                </div>
                <div className="flex-1 rounded-2xl bg-ink-800 p-5 ring-1 ring-white/10 md:p-6" data-id="element-272" data-mp="ffs4ypv9q4kd">
                  <p className="text-sm font-extrabold uppercase tracking-wide text-brand-300" data-id="element-273" data-mp="afvx2fjg9szj">
                    Step {i + 1} — {s.key}
                  </p>
                  <h3 className="mt-1.5 text-xl font-extrabold leading-snug md:text-2xl" data-id="element-274" data-mp="5j5la4eohjjx">{s.title}</h3>
                  <p className="mt-2 text-[16px] leading-relaxed text-mist-200" data-id="element-275" data-mp="3s0xkg447mr3x">{s.body}</p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mt-10 flex flex-col items-center gap-4 rounded-2xl bg-cta-400 p-6 text-center text-ink-950 md:flex-row md:text-left" data-id="element-276" data-mp="3izhhghfq5r9q">
          <AwardIcon className="h-12 w-12 shrink-0" aria-hidden="true" data-id="element-277" data-mp="3n1ku39e4r1wl" />
          <div data-id="element-278" data-mp="ekq2wr6p35yc">
            <p className="text-xl font-extrabold" data-id="element-279" data-mp="emam5knk72gw">The result?</p>
            <p className="mt-1 text-[16px] font-semibold leading-relaxed" data-id="element-280" data-mp="jhq0sete52ed">
              A completed five-stage assessment and planning worksheet that makes your clinical reasoning easier to
              organize, review, communicate, and document.
            </p>
          </div>
        </div>

        <SectionCta label="Get instant access to the 5-step pathway" tone="dark" data-id="element-281" data-mp="xi0qheiysaxy" />
      </div>
    </section>;
}